import { ContainedBtn } from '@components/Buttons';
import { Resource } from '@core';
import { getSeeMoreRelatedMerchantsLink } from '@navigation';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';
import Slider from 'react-slick';
import { useMediaQuery } from 'usehooks-ts';

import PostMerchantsWidgetItem from './components/Item';
import * as styles from './postMerchantsWidget.module.css';

interface Props extends StyleProps, TestIdProps {
  merchants?: Resource[];
}

export const PostMerchantsWidget: FC<Props> = ({ testId, className, merchants }) => {
  if (!merchants || merchants.length === 0) return null;
  const isMobile = useMediaQuery('(max-width: 767px)');
  return (
    <div data-testid={testId} className={mc('px-8 pt-4 pb-4 sm:pb-2 md:pb-8', 'sm:rounded-3xl', 'bg-seafoam/50', className)}>
      <div className={mc('flex flex-col sm:flex-row items-center', 'pb-8', 'border-b border-ugly-blue')}>
        <h6 className={mc('m-0 p-0', 'flex-1', 'text-3xl font-raleway leading-normal font-bold text-ocean-blue')}>
          {'Partners in this Article'}
        </h6>
        <ContainedBtn
          className={mc('hidden sm:block', 'w-[120px] ml-6')}
          color="orange"
          size="xsm"
          fontWeight="medium"
          href={getSeeMoreRelatedMerchantsLink(merchants)}
        >
          {'See More'}
        </ContainedBtn>
      </div>
      {merchants.length <= 3 ? (
        <div className={mc('pt-8 md:-mx-2.5', 'flex flex-col md:flex-row md:justify-between')}>
          {merchants.map(m => (
            <PostMerchantsWidgetItem key={m.id} className={mc('mb-6 md:mb-0 md:mx-2.5', 'md:flex-1')} merchant={m} />
          ))}
        </div>
      ) : (
        <Slider
          className={mc('pt-8 md:-mx-2.5 mb-8 md:mb-0 ', 'relative', styles.slider)}
          dotsClass={styles.dots}
          slidesToShow={isMobile ? 1 : 3}
          infinite={false}
          initialSlide={0}
          dots
          accessibility
        >
          {merchants.map(m => (
            <PostMerchantsWidgetItem key={m.id} className={mc('w-full md:w-[180px] xl:w-[200px] 2xl:w-[230px]')} merchant={m} />
          ))}
        </Slider>
      )}
      <div className={mc('sm:hidden', 'flex flex-row-reverse')}>
        <ContainedBtn
          className={mc('px-8')}
          color="orange"
          size="sm"
          fontWeight="medium"
          href={getSeeMoreRelatedMerchantsLink(merchants)}
        >
          {'See More'}
        </ContainedBtn>
      </div>
    </div>
  );
};

export type PostMerchantsWidgetProps = Props;
export default PostMerchantsWidget;
